import React, {useEffect, useState} from 'react'
import {sanity} from '../lib/sanity'

const CONTACT_QUERY = `*[_type == "contactPage"][0]{
  introText,
  email,
  copyright
}`

function Contact() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    sanity
      .fetch(CONTACT_QUERY)
      .then((result) => {
        setData(result)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  if (loading) return null

  if (!data) {
    return (
      <div className="mx-auto text-center max-w-prose my-24 xl:my-36 px-8 text-[#5757fd]">
        <p className="text-lg font-sans">Geen contactgegevens gevonden.</p>
      </div>
    )
  }

  return (
    <div className="mx-auto text-center max-w-prose my-24 xl:my-36 px-8">
      <div className="text-[#5757fd]">
        <div className="my-12">
          {data.introText && (
            <p className="text-lg font-sans">
              {data.introText}
            </p>
          )}

          {data.email && (
            <a
              href={`mailto:${data.email}`}
              className="text-[#5757fd] block text-3xl font-sans mb-12"
            >
              {data.email}
            </a>
          )}
        </div>

        {data.copyright && (
          <div className="my-12">
            <p className="text-lg font-sans text-[#5757fd]">
              {data.copyright}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Contact